import { UseFormReturn, useWatch } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import useActiveRegions from "@/features/regions/hooks/use-active-regions";
import { codeToFlag } from "@/features/regions/utils/code-to-flag";
import { FormWizardData } from "./wizard-form";

export default function StepClassification({
  form,
}: {
  form: UseFormReturn<FormWizardData>;
}) {
  const { data: regions } = useActiveRegions();
  const selectedRegionId =
    useWatch({ control: form.control, name: "region_id" }) ?? "";
  const selectedRegion = regions?.find((r) => r.id === selectedRegionId);

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="region_id"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Region <span className="text-red-500">*</span>
            </FormLabel>
            <Select value={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select a region">
                    {selectedRegion
                      ? `${codeToFlag(selectedRegion.code)} ${selectedRegion.display_name}`
                      : undefined}
                  </SelectValue>
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {(regions ?? []).map((r) => (
                  <SelectItem key={r.id} value={r.id}>
                    {codeToFlag(r.code)} {r.display_name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="department"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Department <span className="text-red-500">*</span>
              </FormLabel>
              <FormControl>
                <Input placeholder="e.g. Therapy" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="status"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Status</FormLabel>
              <Select value={field.value} onValueChange={field.onChange}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Status" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="ACTIVE">Active</SelectItem>
                  <SelectItem value="INACTIVE">Inactive</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
